import {IAttributes, INgModelController, IRootElementService, IScope} from "angular";
import {PriceStrategy} from "./PriceStrategy";

export const PriceFormat = "priceFormat";

/** @ngInject */
export function priceFormat() {
    return {
        restrict: "A",
        require: "ngModel",
        link: ($scope: IScope, $elem: IRootElementService, $attr: IAttributes, ngModel: INgModelController) => {

            let set = false;

            let strategy: PriceStrategy = $scope.$eval($attr.priceFormat);

            const observer = $attr.$observe("priceFormat", (v: string) => {
                strategy = $scope.$eval(v);
                setFormatters();
            });

            const watcher = $scope.$watch(() => $scope.$eval($attr.priceFormat), (strat) => {
                strategy = strat;
                setFormatters();
            });

            $scope.$on("$destroy", () => {
                observer();
                watcher();
            });

            const setFormatters = () => {
                if (strategy != null && !set) {
                    ngModel.$parsers.push((input) => strategy.parse(input));
                    // Skip invalid values so that they are still shown as the actual value to the user
                    ngModel.$formatters.push((input) => strategy.format(input, true));
                    ngModel.$processModelValue(); // Run the formatters if we've been added after the value has been set
                    set = true;
                }
                ngModel.$processModelValue();
            };

            setFormatters();
        }
    };
}
